import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const HTTP_ERROR_STATUS = 'error';

interface ObjectInterface {
  [key: string]: string;
}
interface ErrorObj {
  errorMessage: string;
  errorStatus: number;
}

type HTTPMethod = 'POST' | 'GET';

const DEFAULT_HEADERS: ObjectInterface = { 'Content-Type': 'application/json' };

class HttpService {
  async request(
    url: string,
    method: HTTPMethod,
    headers: ObjectInterface,
    params = {},
    body?: object
  ) {
    const reqHeaders = { ...DEFAULT_HEADERS, ...headers };
    const config: AxiosRequestConfig = {
      ...params,
      url,
      method: method,
      data: body,
      headers: reqHeaders,
    };

    try {
      return await axios(config);
    } catch (error: any) {
      let errorObj: ErrorObj = { errorMessage: 'Unknown error', errorStatus: 500 };
      if (error.response) {
        errorObj = {
          ...errorObj,
          errorMessage:
            error.response.data.message ||
            error.response.statusText ||
            error.response.data.error ||
            error.message ||
            errorObj.errorMessage,
          errorStatus: error.response.status || errorObj.errorStatus,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        errorObj = { errorMessage: error.message || errorObj.errorStatus, errorStatus: 400 };
      }

      return { data: { status: HTTP_ERROR_STATUS, error: errorObj } };
    }
  }

  get({
    url,
    headers = {},
    params = {},
  }: {
    url: string;
    headers: ObjectInterface;
    params: ObjectInterface;
  }) {
    return this.request(url, 'GET', headers, params);
  }

  post({
    url,
    headers = {},
    params = {},
    body = {},
  }: {
    url: string;
    headers: ObjectInterface;
    params: ObjectInterface;
    body?: object;
  }) {
    return this.request(url, 'POST', headers, params, body);
  }

  parseResponse(res: AxiosResponse | { data: { status: string; error: ErrorObj } }) {
    if (res?.data?.status === HTTP_ERROR_STATUS) return res.data.error;

    return res.data;
  }
}

const httpService = new HttpService();

export { httpService };
